import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "exam-time"
};
const _hoisted_2 = {
  key: 1,
  class: "paper-context reading-paper-context"
};
const _hoisted_3 = {
  key: 0,
  class: "fast-time"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_mm_drag = _resolveComponent("mm_drag");
  const _component_mm_mcq = _resolveComponent("mm_mcq");
  const _component_mcq_mmcq = _resolveComponent("mcq_mmcq");
  const _component_mm = _resolveComponent("mm");
  const _component_MenuBox = _resolveComponent("MenuBox");
  return _openBlock(), _createElementBlock(_Fragment, null, [$setup.paperInfo.items ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_button, {
    style: {
      "background": "none",
      "border": "none",
      "padding": "0",
      "margin-right": "5px",
      "font-size": "20px"
    },
    icon: $setup.Timer,
    size: "large"
  }, null, 8, ["icon"]), _createElementVNode("p", null, [_cache[3] || (_cache[3] = _createTextVNode(" 考试时间", -1)), _createElementVNode("span", null, _toDisplayString($setup.timeText), 1)]), _withDirectives(_createVNode(_component_el_button, {
    color: "#1d5595",
    type: "success",
    size: "large",
    onClick: _cache[0] || (_cache[0] = $event => $setup.finishExam(1))
  }, {
    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("交 卷", -1)]))]),
    _: 1
  }, 512), [[_vShow, $props.examInfo.subdivide == 3]])])) : _createCommentVNode("", true), $setup.paperInfo.items ? (_openBlock(), _createElementBlock("div", _hoisted_2, [$setup.paperInfo.items[$setup.itemNo].isFast ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_button, {
    style: {
      "background": "none",
      "border": "none",
      "padding": "0",
      "margin-right": "5px",
      "font-size": "20px",
      "font-weight": "800"
    },
    icon: $setup.Timer,
    size: "large"
  }, null, 8, ["icon"]), _createTextVNode("快速阅读倒计时 " + _toDisplayString($setup.fastTimeText), 1)])) : _createCommentVNode("", true), $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mm-drag' ? (_openBlock(), _createBlock(_component_mm_drag, {
    key: 1,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mm-mcq' ? (_openBlock(), _createBlock(_component_mm_mcq, {
    key: 2,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mmcq' || $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mcq' || $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'judge' ? (_openBlock(), _createBlock(_component_mcq_mmcq, {
    key: 3,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mm' ? (_openBlock(), _createBlock(_component_mm, {
    key: 4,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $setup.paperInfo.items ? (_openBlock(), _createBlock(_component_MenuBox, {
    key: 2,
    fastTime: $setup.fastTime,
    examType: $props.examInfo.subdivide,
    paperInfo: $setup.paperInfo,
    itemNo: $setup.itemNo,
    answers: $setup.cache.answers,
    onChangePaper: _cache[1] || (_cache[1] = $event => $setup.finishExam(3)),
    onChangeItem: _cache[2] || (_cache[2] = no => {
      if (!$setup.paperInfo.items[no]) {
        $setup.itemNo = 1;
      } else {
        $setup.itemNo = no;
      }
      $setup.setcache();
    })
  }, null, 8, ["fastTime", "examType", "paperInfo", "itemNo", "answers"])) : _createCommentVNode("", true)], 64);
}